import { Tag, TagVariantsNames, TagProps, TagVariant } from './Tag';

import {
	TagDefault,
	TagInformation,
	TagSuccess,
	TagWarning,
	TagDestructive,
	TagBeta,
} from './variations';

export {
	Tag,
	TagDefault,
	TagInformation,
	TagSuccess,
	TagWarning,
	TagDestructive,
	TagBeta,
	TagVariantsNames,
};

export type { TagProps, TagVariant };
